import { IAddToAllEstimatesSelectOption } from '@features/AccessSettingsForm/model/types';

export const addToAllEstimatesData: IAddToAllEstimatesSelectOption[] = [
    {
        // @ts-ignore
        label: i18next.t('AccessSettingsForm.AddToAllEstimatesModal.Select.value.manager'),
        value: 'manager',
    },
    {
        // @ts-ignore
        label: i18next.t('AccessSettingsForm.AddToAllEstimatesModal.Select.value.foreman'),
        value: 'foreman',
    },
    {
        // @ts-ignore
        label: i18next.t('AccessSettingsForm.AddToAllEstimatesModal.Select.value.purchaseAgent'),
        value: 'purchase_agent',
    },
];
